import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateAutomation } from 'modules/settings/api';

export const useMutationUpdateAutomation = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateAutomation, {
    onSuccess: () => {
      successToast(t('Your settings are successfully updated'));
      queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_AUTOMATION);
    },
    onError: () => errorToast(),
  });
};
